import { createSimpleGlobalState } from "src/hooks/simpleGlobalState"
import { DEFAULT_LOCALE, Locale } from "src/translations"

const { getValue, setValue, useValue } = createSimpleGlobalState<Locale>(
  DEFAULT_LOCALE,
  "Locale",
)

export { getValue as getLocale, setValue as setLocale, useValue as useLocale }
